<template>
  <div class="mb-4 markdown" v-if="text" v-html="markdown(text)"></div>
</template>
<script>
import marked from "marked";

export default {
  name: "Markdown",
  props: {
    text: String
  },
  methods: {
    markdown(text) {
      return marked(text);
    }
  }
};
</script>

<style lang="scss">
$quote-color: #666;

.markdown {
  font-weight: 300;

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 300;
    margin-top: 1rem;
    margin-bottom: 0.4rem;
  }
  h1 {
    font-size: 1.7rem;
    line-height: 1.5;
  }
  h2 {
    font-size: 1.5rem;
  }
  h3 {
    font-size: 1.3rem;
  }
  h4,
  h5 {
    font-size: 1.2rem;
  }
  blockquote {
    font-style: italic;
    padding-left: 0.75em;
    border-left: 0.25em solid;
    border-color: lighten($quote-color, 20%);
    color: $quote-color;
  }
}
</style>
